import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-premiere-pro/uxp-premiere-pro/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "closeprojectoptions"
    }}>{`CloseProjectOptions`}</h1>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Min Version`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`promptIfDirty`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`25.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Get whether a prompt is shown if a project is dirty on project open/close`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`showCancelButton`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`25.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Get whether the cancel button is shown on project open/close`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isAppBeingPreparedToQuit`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`25.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Get whether the app is prepared to quit when open/closing a project`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`saveWorkspace`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`25.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Get whether your workspaces are saved when opening/closing a project`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "instance-methods"
    }}>{`Instance Methods`}</h2>
    <h3 {...{
      "id": "setisappbeingpreparedtoquit"
    }}>{`setIsAppBeingPreparedToQuit`}</h3>
    <span className="minversion" style={{
      "display": "block",
      "marginBottom": "-1em",
      "marginLeft": "36em",
      "cssFloat": "left",
      "opacity": "0.5"
    }}>25.0</span>
    <p><em parentName="p">{`CloseProjectOptions`}</em></p>
    <p>{`Set whether the app should be prepared to quit when open/closing a project`}</p>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isAppBeingPreparedToQuit`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "setpromptifdirty"
    }}>{`setPromptIfDirty`}</h3>
    <span className="minversion" style={{
      "display": "block",
      "marginBottom": "-1em",
      "marginLeft": "36em",
      "cssFloat": "left",
      "opacity": "0.5"
    }}>25.0</span>
    <p><em parentName="p">{`CloseProjectOptions`}</em></p>
    <p>{`Set whether to prompt if a project is dirty on project open/close`}</p>
    <h4 {...{
      "id": "parameters-1"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`promptIfDirty`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "setsaveworkspace"
    }}>{`setSaveWorkspace`}</h3>
    <span className="minversion" style={{
      "display": "block",
      "marginBottom": "-1em",
      "marginLeft": "36em",
      "cssFloat": "left",
      "opacity": "0.5"
    }}>25.0</span>
    <p><em parentName="p">{`CloseProjectOptions`}</em></p>
    <p>{`Set whether to save your workspaces when opening/closing a project`}</p>
    <h4 {...{
      "id": "parameters-2"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`isAppBeingPreparedToQuit`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "setshowcancelbutton"
    }}>{`setShowCancelButton`}</h3>
    <span className="minversion" style={{
      "display": "block",
      "marginBottom": "-1em",
      "marginLeft": "36em",
      "cssFloat": "left",
      "opacity": "0.5"
    }}>25.0</span>
    <p><em parentName="p">{`CloseProjectOptions`}</em></p>
    <p>{`Set whether to show the cancel button on project open/close`}</p>
    <h4 {...{
      "id": "parameters-3"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`showCancelButton`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      